import { ExclamationIcon } from '@heroicons/react/outline';
import GenericMessage from 'components/errors/generic-message';

const ResetPasswordFail = () => (
  <GenericMessage
    Icon={<ExclamationIcon className="h-14 w-14 text-red-500" aria-hidden="true" />}
    title="Verification Failed!"
    desc="Your token is either invalid or expired."
  />
);

export default ResetPasswordFail;
